import React, { useState } from "react";
import { useGetMyRentCorpQuery } from "@/redux/rentCorpApi";

export const AosManagerSelectionTable = ({ onSelect, aosManagerData, selectedAosManager }) => {


    const handleAosManagerSelect = (index) => {
        console.log(index);
        onSelect(index);
    };

    return (
        <div className="rent-corp-table-group">
            <label>담당자 목록</label>
            <div className="table-container">
                <div className="table-content">
                    <div className="table-wrapper">
                        <div className="table">
                            <table>
                                <colgroup>
                                    <col width="5%"/>
                                    <col width="15%"/>
                                    <col width="10%"/>
                                    <col width="10%"/>
                                    <col width="10%"/>
                                    <col width="10%"/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">선택</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">AOS ID</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">이름</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">연락처</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">보험사코드</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div className="cell">
                                            <div className="cell-tit">보험사명</div>
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {aosManagerData && aosManagerData.data && aosManagerData.data.length > 0 ? (
                                    aosManagerData.data.map((aosManager, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="cell" style={{height: "100%"}}>
                                                        <div className="input-checkbox">
                                                            <div className="checkbox" style={{display: "flex"}}>
                                                                <input
                                                                    type="radio"
                                                                    name="selectedAosManager"
                                                                    id={`selectedAosManager-${index}`}
                                                                    checked={selectedAosManager === index}
                                                                    onChange={() => handleAosManagerSelect(index)}
                                                                />
                                                                <label htmlFor={`selectedAosManager-${index}`}></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosManager.aosid}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosManager.usernm}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosManager.mobilenum}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosManager.inscd}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">{aosManager.insnm}</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="data-empty">
                                                <div className="cell" data-align="center">
                                                    <span className="cell-desc">담당자 데이터가 없습니다.</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
